import { Component, ElementRef, OnInit, ViewChild, OnDestroy, OnChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { fuseAnimations } from '../../../core/animations';
import { MatPaginator, MatSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import { Router } from "@angular/router";
import * as firebase from 'firebase';
import { MatDialog } from '@angular/material';
import { DialogComponent } from './dialog/dialog.component';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators/map';
import { Subscription } from 'rxjs/Subscription';



@Component({
    selector: 'app-addtoblackphoto',
    templateUrl: './addtoblackphoto.component.html',
    styleUrls: ['./addtoblackphoto.component.scss'],
    animations: fuseAnimations
})
export class AddToBlackPhotoComponent implements OnInit, OnDestroy {

    displayedColumns = ['user', 'date', 'delete'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    number: any;
    posts: Array<any>;
    input: any;
    dataSource: MyDataSource;
    filteredItems: Array<any>;
    searchpost: Array<any>;
    private sub: any;
    private sub1 = new Subscription();
    private sub2 = new Subscription();
    filteredPosts = [];
    db = firebase.firestore();

    constructor(

        private afs: AngularFirestore,
        private router: Router,
        private cd: ChangeDetectorRef,
        private dialog: MatDialog) {



        this.sub = this.afs.collection('posts', ref => ref.orderBy('order').limit(10)).snapshotChanges().pipe(map(actions => {
            return actions.map(a => {
                return {
                    $key: a.payload.doc.id,
                    ...a.payload.doc.data()
                }
            })
        })).subscribe(user => {
            this.filteredPosts = user
            this.posts = this.filteredPosts;
            this.number = 30000;
            this.searchpost = this.posts;
            this.dataSource = new MyDataSource(this.posts, this.paginator, this.sort);
            console.log(this.dataSource)
            this.cd.markForCheck();


        });
    }

    ngOnInit() {


    }


    handlePage(event) {
        console.log(event)
        this.sub.unsubscribe();
        if (event.pageIndex === 0 && event.pageSize !== 10) {
            this.sub2.unsubscribe();
            this.sub1 = this.afs.collection('posts', ref => ref.orderBy('order').limit(event.pageSize)).snapshotChanges().pipe(map(actions => {
                return actions.map(a => {
                    return {
                        $key: a.payload.doc.id,
                        ...a.payload.doc.data()
                    }
                })
            })).subscribe(user => {
                this.filteredPosts = user
                this.posts = this.filteredPosts;
                this.number = 30000;
                this.searchpost = this.posts;
                this.dataSource = new MyDataSource(this.posts, this.paginator, this.sort);
                console.log(this.dataSource)
                this.cd.markForCheck();


            });

        }
        else {
            this.sub1.unsubscribe();
            var first = this.db.collection("posts")
                .orderBy("order")
                .limit(event.pageIndex * event.pageSize);


            first.get().then(documentSnapshots => {
                var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
                this.sub2 = this.afs.collection('posts', ref => ref.orderBy('order').startAfter(lastVisible).limit(event.pageSize)).snapshotChanges().pipe(map(actions => {
                    return actions.map(a => {
                        return {
                            $key: a.payload.doc.id,
                            ...a.payload.doc.data()
                        }
                    })
                })).subscribe(user => {

                    this.filteredPosts = user
                    this.posts = this.posts.concat(this.filteredPosts);
                    this.number = 30000;
                    this.searchpost = user;
                    console.log(this.posts);
                    this.dataSource = new MyDataSource(this.posts, this.paginator, this.sort);
                    this.cd.markForCheck();
                    console.log(this.dataSource)


                });



            });
        }

    }
    changeTextCategory(string) {
        return string
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/ç/g, 'c')
            .replace(/Ç/g, 'c')
            .replace(/ş/g, 's')
            .replace(/Ş/g, 's')
            .replace(/ı/g, 'i')
            .replace(/İ/g, 'i')
            .replace(/ğ/g, 'g')
            .replace(/Ğ/g, 'g')
            .replace(/ü/g, 'u')
            .replace(/Ü/g, 'u')
            .replace('&', 've')
            .replace(/,/g, '')
            .replace(/\./g, '_')
            .replace(/\'/g, '')
            .replace(/\s/g, '_').toLowerCase();
    }
    searchKeyUp(event) {
        console.log(this.input);
        const searchInput = this.input.replace(/\s/g, '').replace(/@/g, '').replace(/,/g, '').replace(/'/g, '').replace(/\./g, '').toLowerCase().trim();
        this.filteredItems = this.searchpost.filter(
            item => {


                if (item.author) {


                    return this.changeTextCategory(item.author.firstname + ' ' + item.author.lastname).indexOf(this.changeTextCategory(this.input)) > -1
                }
            });
        this.dataSource = new MyDataSource(this.filteredItems, this.paginator, this.sort);
    }
    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }

        if (this.sub1) {
            this.sub1.unsubscribe();
        }
        if (this.sub2) {
            this.sub2.unsubscribe();
        }
    }
    navigate(key) {
        console.log(key)
        this.router.navigate(['/userlist-photo'], { queryParams: { name: key } });
    }
    censorContent(key) {
        this.dialog.open(DialogComponent, {

            data: {
                key: key
            }
        });
    }

}

export class MyDataSource extends DataSource<any> {
    constructor(
        private data: any,
        private _paginator: MatPaginator,
        private _sort: MatSort) {
        super();
    }
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any) {
        this._filteredDataChange.next(value);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }
    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.data,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];
        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.data.slice();

            this.filteredData = [...data];

            data = this.sortData(data);

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    sortData(data): any[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch (this._sort.active) {
                case 'id':
                    [propertyA, propertyB] = [a.id, b.id];
                    break;
                case 'name':
                    [propertyA, propertyB] = [a.name, b.name];
                    break;
                case 'categories':
                    [propertyA, propertyB] = [a.categories[0], b.categories[0]];
                    break;
                case 'price':
                    [propertyA, propertyB] = [a.priceTaxIncl, b.priceTaxIncl];
                    break;
                case 'quantity':
                    [propertyA, propertyB] = [a.quantity, b.quantity];
                    break;
                case 'active':
                    [propertyA, propertyB] = [a.active, b.active];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    disconnect() { }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/addtoblackphoto/addtoblackphoto.component.ts